import { render } from "./delivery.vue?vue&type=template&id=d83f32ac&scoped=true"
import script from "./delivery.vue?vue&type=script&lang=js"
export * from "./delivery.vue?vue&type=script&lang=js"

import "./delivery.vue?vue&type=style&index=0&id=d83f32ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d83f32ac"]])

export default __exports__